// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-container .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  height: 5vh !important;
  width: 328px !important;
  border-radius: 9px !important;
}
.Login-container .css-1v4ccyo {
  height: 5vh !important;
  width: 324px !important;
  border-radius: 9px !important;
}
.Login-container .textField-container {
  width: 100%;
  height: 9vh;
}
.Login-container .textField-container .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  height: 0px !important;
}
.Login-container .textField-container .css-1x5jdmq {
  height: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/style.scss"],"names":[],"mappings":"AACI;EACI,sBAAA;EACA,uBAAA;EACA,6BAAA;AAAR;AAEI;EACI,sBAAA;EACA,uBAAA;EACA,6BAAA;AAAR;AAEI;EACI,WAAA;EACA,WAAA;AAAR;AACQ;EACI,sBAAA;AACZ;AACQ;EACI,sBAAA;AACZ","sourcesContent":[".Login-container {\r\n    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\r\n        height: 5vh !important;\r\n        width: 328px !important;\r\n        border-radius: 9px !important;\r\n    }\r\n    .css-1v4ccyo {\r\n        height: 5vh !important;\r\n        width: 324px !important;\r\n        border-radius: 9px !important;\r\n    }\r\n    .textField-container{\r\n        width:100%;\r\n        height:9vh;\r\n        .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\r\n            height: 0px !important;\r\n        }\r\n        .css-1x5jdmq{\r\n            height: 0px !important;\r\n        }\r\n        // border:2px solid blue\r\n        // display: flex;\r\n        // justify-content:;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
